import { ContentCard } from "@msuite/ui/content-card";
import { icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { useQuery } from "@msuite/ui/query";
import { joinJSXElements, responseHandler } from "@msuite/ui/utils";
import { guardString } from "@msuite/utils/strings";
import { client } from "@/hono";
import type { VehiclePanelBaseProps } from "@/sites/vehicles/vehicle/shared";

export function VehicleHeader({ vehicleId }: VehiclePanelBaseProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Query */
	const { data: vehicle } = useQuery({
		queryKey: ["vehicle", vehicleId],
		queryFn: async () => {
			const response = await client.vehicles[":vehicleId"].$get({
				param: { vehicleId },
			});
			const data = await responseHandler(response);
			return data.vehicle;
		},
	});

	const items = joinJSXElements([
		vehicle?.licensePlate ? <span key="license-plate">{vehicle.licensePlate}</span> : null,
	]);

	/** Render */
	return (
		<ContentCard
			title={vehicle?.type ? t(`vehicles.types.${vehicle?.type}`) : guardString(null)}
			icon={icon("Car")}
			// The plate, not the type, is what tells one vehicle from the next.
			identifier={vehicle ? vehicleId : undefined}
			dataPageBreadcrumbsTitle={vehicle?.licensePlate ?? undefined}
		>
			<div className="h-stack">{items}</div>
		</ContentCard>
	);
}
